import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";

var SandwichContentItem = function SandwichContentItem(_ref) {
  var children = _ref.children;
  var getClassName = getClassNameFactory("SandwichContentItem");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, children);
};

SandwichContentItem.displayName = "Sandwich.ContentItem";
/* eslint-disable max-len */

SandwichContentItem.propTypes = {
  /**
   * Button component
   */
  children: PropTypes.node.isRequired
};
/* eslint-enable max-len */

export default SandwichContentItem;